import React from 'react'
import { BrowserRouter, Redirect, Route } from 'react-router-dom';
import './App.css';
import Provider from './context/Provider';
import Login from './pages/Login';
import Home from './pages/Home';
import Header from './components/Header';
import Burger from './components/Burguer';
import Config from './pages/Config';
import CallCenter from './pages/Callcenter'
import CallcenterV2 from './pages/CallcenterV2'
import CallcenterV2Layout from './pages/CallcenterV2/Layout'
import CallcenterV2Queues from './pages/CallcenterV2/QueuesConfig'
import CallcenterV2Skills from './pages/CallcenterV2/SkillsConfig'
import CallcenterV2Agents from './pages/CallcenterV2/AgentsConfig'
import CallcenterV2Reports from './pages/CallcenterV2/Reports'
import CallcenterV2History from './pages/CallcenterV2/History'
import CallcenterV2Dashboard from './pages/CallcenterV2/Dashboard'
import CallcenterV2MetricsCatalog from './pages/CallcenterV2/MetricsCatalog'
import CallcenterV2DashboardRouter from './pages/CallcenterV2/DashboardRouter'
import CallcenterV2DashboardManager from './pages/CallcenterV2/DashboardManager'
import CallcenterV2DashboardAgent from './pages/CallcenterV2/DashboardAgent'
import CallcenterV2PauseReasons from './pages/CallcenterV2/PauseReasons'
import CallcenterV2WorkSchedules from './pages/CallcenterV2/WorkSchedules'
import CallcenterV2MetricsCatalogAdmin from './pages/CallcenterV2/MetricsCatalogAdmin'
import CallcenterV2FeatureFlags from './pages/CallcenterV2/FeatureFlags'
import CallcenterV2Realtime from './pages/CallcenterV2/Realtime'
import CallcenterV2AuditLog from './pages/CallcenterV2/AuditLog'
import CallcenterV2Campaigns from './pages/CallcenterV2/Campaigns'
import CallcenterV2CampaignDetail from './pages/CallcenterV2/Campaigns/CampaignDetail'
import CallcenterV2Dnc from './pages/CallcenterV2/Campaigns/Dnc'
import CreateEndpoints from './components/Config/Endpoints/EndpointsCreate';
import ListEndpoints from './components/Config/Endpoints/EndpointsList';
import ListEndpointsById from './components/Config/Endpoints/EndpointsListById';
import CreateTrunks from './components/Config/Trunks/TrunksCreate';
import EditTrunks from './components/Config/Trunks/TrunksEdit';
import ListTrunks from './components/Config/Trunks/TrunksList';
import ListTrunksById from './components/Config/Trunks/TrunksListById';
import TrunksInboundDispatcherManage from './components/Config/Trunks/TrunksInboundDispatcherManage';
import ChangeIp from './components/Config/System/ChangeIp';
import InterfacesList from './components/Config/System/InterfacesList';
import PjsipTransports from './components/Config/Asterisk/PjsipTransports';
import PjsipTuning from './components/Config/Asterisk/PjsipTuning';
import QueuesCreate from './components/Config/Queues/QueuesCreate';
import QueuesList from './components/Config/Queues/QueuesList';
import QueuesListById from './components/Config/Queues/QueuesListById';
import QueueMembersRoster from './components/Config/Queues/QueueMembersRoster';
import QueuesMembersList from './components/Config/Queues/QueuesMembersList';
import RoutesNewSet from './components/Config/System/RoutesNew';
import RoutesList from './components/Config/System/RoutesList';
import PortRedirects from './components/Config/System/PortRedirects';
import RecordingsBackup from './components/Config/System/RecordingsBackup/RecordingsBackup';
import MemberQueuesById from './components/Config/Queues/components/MembersListById';
import DialPlanEntrance from './components/Config/DialPlan/DialPlanEntranceCalls';
import DialPlanInternal from './components/Config/DialPlan/DialPlanInternalCalls';
import DialPlanExternal from './components/Config/DialPlan/DialPlanExternalCalls';
import CreateUsers from './components/Config/Users/UsersCreate';
import ListUsers from './components/Config/Users/UsersList';
import UsersEdit from './components/Config/Users/UsersEdit';
import UsersView from './components/Config/Users/UsersView';
import ListContacts from './components/Contacts/ContactsList';
import NewContact from './components/Contacts/ContactsCreate';
import ContactById from './components/Contacts/ContactsListById';
import ContactShowById from './components/Contacts/ContactsShowById';
import LogsVigoscloud from './components/Events/LogsVigoscloud';
import PingPage from './components/Config/System/PingIp';
import Dashboard from './pages/Dashboard/index';
import Uploads from './components/Config/Uploads/UraAndMohUpdate';
import UploadsList from './components/Config/Uploads/UraAndMohList';
import Tenants from './components/Config/Tenant/TenantCreate';
import TenantsList from './components/Config/Tenant/TenantsList';
import CrossTenantCalls from './components/Config/Tenant/CrossTenantCalls';
import MohCreate from './components/Config/Moh/MohCreate';
import MohEdit from './components/Config/Moh/MohEdit';
import MohList from './components/Config/Moh/MohList';
import MohView from './components/Config/Moh/MohView';
import IntegrationsList from './components/Config/Integrations/IntegrationsList';
import IntegrationsCreate from './components/Config/Integrations/IntegrationsCreate';
import IntegrationsEdit from './components/Config/Integrations/IntegrationsEdit';
import IntegrationsView from './components/Config/Integrations/IntegrationsView';
import InternalCallsList from './components/Config/InternalCalls/InternalCallsList';
import InternalCallsCreate from './components/Config/InternalCalls/InternalCallsCreate';
import InternalCallsEdit from './components/Config/InternalCalls/InternalCallsEdit';
import InternalCallsView from './components/Config/InternalCalls/InternalCallsView';
import InternalCallsStatistics from './components/Config/InternalCalls/InternalCallsStatistics';
import OutboundCallsList from './components/Config/OutboundCalls/OutboundCallsList';
import OutboundCallsCreate from './components/Config/OutboundCalls/OutboundCallsCreate';
import OutboundCallsEdit from './components/Config/OutboundCalls/OutboundCallsEdit';
import OutboundCallsView from './components/Config/OutboundCalls/OutboundCallsView';
import OutboundGroupsList from './components/Config/OutboundCalls/OutboundGroupsList';
import OutboundGroupsCreate from './components/Config/OutboundCalls/OutboundGroupsCreate';
import OutboundGroupsEdit from './components/Config/OutboundCalls/OutboundGroupsEdit';
import CarriersList from './components/Config/Carriers/CarriersList';
import CarriersForm from './components/Config/Carriers/CarriersForm';

import IncomingCallsList from './components/Config/IncomingCalls/IncomingCallsList';
import IncomingCallsCreate from './components/Config/IncomingCalls/IncomingCallsCreate';
import IncomingCallsCreateRange from './components/Config/IncomingCalls/IncomingCallsCreateRange';
import IncomingCallsEdit from './components/Config/IncomingCalls/IncomingCallsEdit';
import IncomingCallsView from './components/Config/IncomingCalls/IncomingCallsView';

import URAList from './components/Config/URA/URAList';
import URACreate from './components/Config/URA/URACreate';
import URAEdit from './components/Config/URA/URAEdit';
import CsatSurveysList from './components/Config/Csat/CsatSurveysList';
import CsatSurveyForm from './components/Config/Csat/CsatSurveyForm';
import Csat from './pages/Csat';
import IncomingCallsStatistics from './components/Config/IncomingCalls/IncomingCallsStatistics';

import MessageList from './components/Config/Message/MessageList';
import MessageCreate from './components/Config/Message/MessageCreate';
import MessageEdit from './components/Config/Message/MessageEdit';

import CallInactivityConfig from './components/Config/CallInactivity/CallInactivityConfig';
import CallInactivityHistory from './components/Config/CallInactivity/CallInactivityHistory';

import Fail2banDashboard from './components/Security/Fail2ban/Fail2banDashboard';

import RequireFeature from './components/Common/RequireFeature';

const featureRoute = (path, feature, action, Component) => (
  <Route
    exact
    path={path}
    render={(props) => (
      <RequireFeature feature={feature} action={action}>
        <Component {...props} />
      </RequireFeature>
    )}
  />
);

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Provider>
          <div className="is-justify-content-end">
            <Header />
            <Burger />
            <Route exact path="/" component={ Login } />
            <Route exact path="/home" component={ Home } />
            <Route exact path="/dashboard" component={ Dashboard } />
            <Route exact path="/callcenter" component={ CallCenter } />
            <Route exact path="/callcenterV2" render={() => <CallcenterV2Layout><CallcenterV2 /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/dashboard" render={() => <CallcenterV2Layout><CallcenterV2DashboardRouter /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/history" render={() => <CallcenterV2Layout><CallcenterV2History /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/queues" render={() => <CallcenterV2Layout><CallcenterV2Queues /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/skills" render={() => <CallcenterV2Layout><CallcenterV2Skills /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/agents" render={() => <CallcenterV2Layout><CallcenterV2Agents /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/reports" render={() => <CallcenterV2Layout><CallcenterV2Reports /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/metrics/catalog" render={() => <CallcenterV2Layout><CallcenterV2MetricsCatalogAdmin /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/dashboard/manager" render={() => <CallcenterV2Layout><CallcenterV2DashboardManager /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/dashboard/agent" render={() => <CallcenterV2Layout><CallcenterV2DashboardAgent /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/pause-reasons" render={() => <CallcenterV2Layout><CallcenterV2PauseReasons /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/work-schedules" render={() => <CallcenterV2Layout><CallcenterV2WorkSchedules /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/metrics/catalog-admin" render={() => <CallcenterV2Layout><CallcenterV2MetricsCatalogAdmin /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/feature-flags" render={() => <CallcenterV2Layout><CallcenterV2FeatureFlags /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/realtime" render={() => <CallcenterV2Layout><CallcenterV2Realtime /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/audit" render={() => <CallcenterV2Layout><CallcenterV2AuditLog /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/campaigns" render={() => <CallcenterV2Layout><CallcenterV2Campaigns /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/campaigns/dnc" render={() => <CallcenterV2Layout><CallcenterV2Dnc /></CallcenterV2Layout>} />
            <Route exact path="/callcenterV2/campaigns/:id(\d+)" render={() => <CallcenterV2Layout><CallcenterV2CampaignDetail /></CallcenterV2Layout>} />
            <Route exact path="/config" component={ Config } />
            {featureRoute('/config/ramal/novo', 'config.ramais', 'create', CreateEndpoints)}
            {featureRoute('/config/ramal/lista', 'config.ramais', 'view', ListEndpoints)}
            {featureRoute('/config/ramal/id', 'config.ramais', 'view', ListEndpointsById)}
            {featureRoute('/config/tronco/novo', 'config.troncos', 'create', CreateTrunks)}
            {featureRoute('/config/tronco/adicionar', 'config.troncos', 'create', CreateTrunks)}
            {featureRoute('/config/tronco/editar', 'config.troncos', 'edit', EditTrunks)}
            {featureRoute('/config/tronco/lista', 'config.troncos', 'view', ListTrunks)}
            {featureRoute('/config/tronco/id', 'config.troncos', 'view', ListTrunksById)}
            <Route exact path="/config/tronco/inbound-dispatcher" component={ TrunksInboundDispatcherManage } />
            <Route exact path="/config/rede/ip" component={ ChangeIp } />
            <Route exact path="/config/rede/ip/lista" component={ InterfacesList } />
            <Route exact path="/config/rede/ip/routes" component={ RoutesNewSet } />
            <Route exact path="/config/rede/ip/routes/lista" component={ RoutesList } />
            <Route exact path="/config/rede/transportes-voz" component={ PjsipTransports } />
            <Route exact path="/config/rede/pjsip-tuning" component={ PjsipTuning } />
            {featureRoute('/config/rede/redirect-portas', 'config.redes', 'view', PortRedirects)}
            {featureRoute('/config/sistema/backup-gravacoes', 'system.backup_gravacoes', 'view', RecordingsBackup)}
            {featureRoute('/config/fila/nova', 'config.filas', 'create', QueuesCreate)}
            {featureRoute('/config/fila/lista', 'config.filas', 'view', QueuesList)}
            {featureRoute('/config/fila/lista/nome', 'config.filas', 'view', QueuesListById)}
            <Route exact path="/config/fila/membros/novo" render={() => <Redirect to="/config/fila/lista" />} />
            {featureRoute('/config/fila/membros/gerenciar', 'config.filas', 'edit', QueueMembersRoster)}
            {featureRoute('/config/fila/membros/lista', 'config.filas', 'view', QueuesMembersList)}
            {featureRoute('/config/fila/membros/lista/id', 'config.filas', 'edit', MemberQueuesById)}
            <Route exact path="/config/direcionamentos/entrada" component={ DialPlanEntrance } />
            <Route exact path="/config/direcionamentos/interno" component={ DialPlanInternal } />
            <Route exact path="/config/direcionamentos/externo" component={ DialPlanExternal } />
            <Route exact path="/config/usuarios/novo" component={ CreateUsers } />
            <Route exact path="/config/usuarios/lista" component={ ListUsers } />
            <Route exact path="/config/usuarios/editar" component={ UsersEdit } />
            <Route exact path="/config/usuarios/visualizar" component={ UsersView } />
            {featureRoute('/config/uploads', 'config.uploads', 'create', Uploads)}
            <Route exact path="/config/clientes/novo" component={ Tenants } />
            <Route exact path="/config/clientes/lista" component={ TenantsList } />
            <Route exact path="/config/clientes/cross-tenant" component={ CrossTenantCalls } />
            {featureRoute('/config/uploads/lista', 'config.uploads', 'view', UploadsList)}
            <Route exact path="/agenda/lista" component={ ListContacts } />
            <Route exact path="/agenda/novo" component={ NewContact } />
            <Route exact path="/agenda/contato/id" component={ ContactById } />
            <Route exact path="/agenda/contato/visualizar" component={ ContactShowById } />
            {featureRoute('/troubleshooting/sip', 'troubleshooting.sip', 'view', LogsVigoscloud)}
            {featureRoute('/troubleshooting/comandos', 'troubleshooting.conectividade', 'view', PingPage)}
            {featureRoute('/config/musica-de-espera/novo', 'config.moh', 'create', MohCreate)}
            {featureRoute('/config/musica-de-espera/editar', 'config.moh', 'edit', MohEdit)}
            {featureRoute('/config/musica-de-espera/lista', 'config.moh', 'view', MohList)}
            {featureRoute('/config/musica-de-espera/visualizar', 'config.moh', 'view', MohView)}
            {featureRoute('/config/integracoes/lista', 'config.integracoes', 'view', IntegrationsList)}
            {featureRoute('/config/integracoes/nova', 'config.integracoes', 'create', IntegrationsCreate)}
            {featureRoute('/config/integracoes/editar', 'config.integracoes', 'edit', IntegrationsEdit)}
            {featureRoute('/config/integracoes/visualizar', 'config.integracoes', 'view', IntegrationsView)}
            {featureRoute('/config/chamadas/internas', 'config.chamadas.internas', 'view', InternalCallsList)}
            {featureRoute('/config/chamadas/internas/nova', 'config.chamadas.internas', 'create', InternalCallsCreate)}
            {featureRoute('/config/chamadas/internas/editar', 'config.chamadas.internas', 'edit', InternalCallsEdit)}
            {featureRoute('/config/chamadas/internas/visualizar', 'config.chamadas.internas', 'view', InternalCallsView)}
            {featureRoute('/config/chamadas/internas/estatisticas', 'config.chamadas.internas', 'view', InternalCallsStatistics)}

            {featureRoute('/config/chamadas/saida', 'config.chamadas.saida', 'view', OutboundCallsList)}
            {featureRoute('/config/chamadas/saida/nova', 'config.chamadas.saida', 'create', OutboundCallsCreate)}
            {featureRoute('/config/chamadas/saida/editar', 'config.chamadas.saida', 'edit', OutboundCallsEdit)}
            {featureRoute('/config/chamadas/saida/visualizar', 'config.chamadas.saida', 'view', OutboundCallsView)}
            {featureRoute('/config/chamadas/saida/grupos', 'config.chamadas.saida', 'view', OutboundGroupsList)}
            {featureRoute('/config/chamadas/saida/grupos/novo', 'config.chamadas.saida', 'create', OutboundGroupsCreate)}
            {featureRoute('/config/chamadas/saida/grupos/editar', 'config.chamadas.saida', 'edit', OutboundGroupsEdit)}
            {featureRoute('/config/carriers', 'config.carriers', 'view', CarriersList)}
            {featureRoute('/config/carriers/new', 'config.carriers', 'create', CarriersForm)}
            {featureRoute('/config/carriers/:carrierId/edit', 'config.carriers', 'edit', CarriersForm)}

            {featureRoute('/config/chamadas-entrada', 'config.chamadas.entrada', 'view', IncomingCallsList)}
            {featureRoute('/config/chamadas-entrada/criar', 'config.chamadas.entrada', 'create', IncomingCallsCreate)}
            {featureRoute('/config/chamadas-entrada/criar-faixa', 'config.chamadas.entrada', 'create', IncomingCallsCreateRange)}
            {featureRoute('/config/chamadas-entrada/:id/editar', 'config.chamadas.entrada', 'edit', IncomingCallsEdit)}
            {featureRoute('/config/chamadas-entrada/:id/visualizar', 'config.chamadas.entrada', 'view', IncomingCallsView)}
            {featureRoute('/config/chamadas-entrada/estatisticas', 'config.chamadas.entrada', 'view', IncomingCallsStatistics)}

            {featureRoute('/config/ura', 'config.chamadas.uras', 'view', URAList)}
            {featureRoute('/config/ura/create', 'config.chamadas.uras', 'create', URACreate)}
            {featureRoute('/config/ura/edit/:id', 'config.chamadas.uras', 'edit', URAEdit)}

            {featureRoute('/config/csat', 'config.chamadas.csat', 'view', CsatSurveysList)}
            {featureRoute('/config/csat/new', 'config.chamadas.csat', 'create', CsatSurveyForm)}
            {featureRoute('/config/csat/:id/edit', 'config.chamadas.csat', 'edit', CsatSurveyForm)}

            {featureRoute('/csat', 'relatorios.csat', 'view', Csat)}

            {featureRoute('/config/message', 'config.chamadas.mensagens', 'view', MessageList)}
            {featureRoute('/config/message/create', 'config.chamadas.mensagens', 'create', MessageCreate)}
            {featureRoute('/config/message/edit/:id', 'config.chamadas.mensagens', 'edit', MessageEdit)}

            {featureRoute('/config/monitoramento-inatividade/configuracao', 'config.monitoramento', 'view', CallInactivityConfig)}
            {featureRoute('/config/monitoramento-inatividade/historico', 'config.monitoramento', 'view', CallInactivityHistory)}

            <Route exact path="/seguranca/fail2ban" component={ Fail2banDashboard } />
          </div>
        </Provider>
      </BrowserRouter>
    );
  }
}

export default App;
